<template>
  <div />
</template>

<script setup lang="ts">
// Intentionally blank: navigation is handled by router guards.
</script>


